import api from './api';

interface BookingData {
    personalInfo: {
        name: string;
        phoneNumber: string;
        email: string;
        notificationPreference: string;
        message?: string;
    };
    retreat: string;
    selectedDate: {
        startDate: string;
        endDate: string;
    };
    numberOfGuests: number;
    guests: {
        name: string;
        email: string;
        phoneNumber: string;
    }[];
    selectedAccommodation: string;
    paymentInfo: {
        paymentType: 'full' | 'deposit';

        paymentMethod: 'card' | 'bank_transfer';
        currency: string;
        cardInfo?: {
            cardNumber: string;
            expiryMonth: string;
            expiryYear: string;
            cvv: string;
            nameOnCard: string;
        };
    };
}

interface BookingResponse {
    success: boolean;
    data: {
        bookingId: string;
        status: string;
        paymentUrl?: string;
    };
    message: string;
}

export const bookingService = {
    // Create a new booking
    createBooking: async (bookingData: BookingData): Promise<BookingResponse> => {
        const response = await api.post('/booking', bookingData);
        return response.data;
    },

    // Get booking by ID
    getBookingById: async (bookingId: string) => {
        const response = await api.get(`/booking/${bookingId}`);
        return response.data;
    },

    // Get user's bookings
    getUserBookings: async (page: number = 1, limit: number = 10) => {
        const response = await api.get(`/booking/user?page=${page}&limit=${limit}`);
        return response.data;
    },

    // Cancel booking
    cancelBooking: async (bookingId: string) => {
        const response = await api.put(`/booking/${bookingId}/cancel`);
        return response.data;
    },

    // Update booking
    updateBooking: async (bookingId: string, updateData: Partial<BookingData>) => {
        const response = await api.put(`/booking/${bookingId}`, updateData);
        return response.data;
    }
};